import Footer from "../../Footer/Footer";
import Header from "../../Header/Header";

import BlockContent from "../../Block/BlockContent";
import BlockTitle from "../../Block/BlockTitle";
import BlockSubtitle from "../../Block/BlockSubtitle";
import BlockText from "../../Block/BlockText";
import BlockButton from "../../Block/BlockButton";
import Block from "../../Block/Block";
import BlockImage from "../../Block/BlockImage";

function EVA() {
  return (
    <div>
      <Header/>        

      <div style={{backgroundImage:'url("/Home/pointwave.webp")', 
                  height:"200px",
                  width: "100%",
                  backgroundSize: "100% 100%",
                  backgroundPosition: "bottom"}}>
      </div>

      <Block colorTheme="light" gridTemplateColumns="600px 600px">
        <BlockContent>
          <BlockTitle>EVA Dataset</BlockTitle>
          <BlockSubtitle>Enhanced Visual Archive</BlockSubtitle>
        </BlockContent>
        <BlockContent>
          <BlockText>The <i>Enhanced Visual Archive</i> is a dataset comprising various 3D reconstructions of small to medium-sized objects created using techniques such as photogrammetry and structured light. This is an ongoing project, meaning new objects are continuously being added.</BlockText>
        </BlockContent>
      </Block>

      <Block gridTemplateColumns="600px 600px">
        <BlockContent>
          <BlockText>The Enhanced Visual Archive is a dataset featuring 3D reconstructions of everyday objects, ranging from minerals and toys to larger items such as statues. The dataset can be explored using our visualizer, accessible via the button below. The visualizer provides an interactive experience, allowing users to examine the reconstructions in detail from multiple angles and perspectives.
          </BlockText>
        </BlockContent>
        <BlockContent>
              <BlockImage src={process.env.PUBLIC_URL + '/images/project_cards/card_eva2.webp'} title="Figure 1: Examples from the EVA Dataset"/>
        </BlockContent>
      </Block>


      <Block colorTheme="light" gridTemplateColumns="1200px">
        <BlockContent width="10%" textAlign="center" color="grey" fontStyle="italic">
          <BlockButton width="150px" onClick={() => window.open("https://potechius.com/EvaVisualiser/")}>
          <img className="BlockButton-img" src={process.env.PUBLIC_URL + '/icon_public.webp'} alt=""/> Visualizer</BlockButton>
        </BlockContent>
        {/* <BlockContent width="10%" textAlign="center" color="grey" fontStyle="italic">
          <BlockButton width="150px" onClick={() => window.open("https://potechius.com/EvaVisualiser/")}>
          <img className="BlockButton-img" src={process.env.PUBLIC_URL + '/icon_private.webp'} alt=""/> Visualizer</BlockButton>
        </BlockContent> */}
      </Block>


      <Footer/>
    </div>
  );
}

export default EVA;